/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  Paper,
  Alert,
  CircularProgress,
} from "@mui/material";

// IMPORTANT: Replace YOUR_FORM_ID below with your actual Formspree form ID
// Get your form ID by creating a form at https://formspree.io/
const ContactForm = () => {
  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    error: false,
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ submitting: true, submitted: false, error: false });

    const form = event.target;

    try {
      const response = await fetch("https://formspree.io/f/meoawgnj", {
        method: "POST",
        body: new FormData(form),
        headers: {
          Accept: "application/json",
        },
      });

      if (response.ok) {
        setStatus({ submitting: false, submitted: true, error: false });
        form.reset();
      } else {
        const data = await response.json();
        throw new Error(data.error || "Form submission failed");
      }
    } catch (error) {
      console.error("Form error:", error);
      setStatus({ submitting: false, submitted: false, error: true });
    }
  };

  return (
    <Paper elevation={3} className="p-6 rounded-lg">
      <Typography variant="h5" component="h2" className="font-bold mb-6">
        Get in Touch
      </Typography>
      <Typography variant="body2" color="text.secondary" className="mb-6">
        Fill out the form below, and we'll get back to you as soon as possible.
      </Typography>

      {status.submitted && (
        <Alert severity="success" className="mb-4">
          Thanks for your message! We'll get back to you soon.
        </Alert>
      )}

      {status.error && (
        <Alert severity="error" className="mb-4">
          There was a problem submitting your form. Please try again.
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              label="Full Name"
              variant="outlined"
              name="name"
              disabled={status.submitting}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              label="Phone Number"
              variant="outlined"
              name="phone"
              disabled={status.submitting}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label="Email Address"
              variant="outlined"
              type="email"
              name="email"
              disabled={status.submitting}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label="Subject"
              variant="outlined"
              name="subject"
              disabled={status.submitting}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label="Message"
              variant="outlined"
              multiline
              rows={4}
              name="message"
              disabled={status.submitting}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              className="bg-blue-600 hover:bg-blue-700 py-3"
              disabled={status.submitting}
            >
              {status.submitting ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Send Message"
              )}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default ContactForm;
